// Copyright (c) Docugami, Inc. All rights reserved.

import { InfoView } from "components/work_path/InfoView";
import styled from "styled-components";
import emptyDocSetsUrl from "assets/EmptyDocSet.png";
import { ISpinnerStyles, Spinner } from "@fluentui/react";

const Container = styled.div`
    width: 100%;
    height: 100%;
    background: #FFFFFFBF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
`

const CoachmarkIcon = styled.img`
    width: 350px;
`

//This exists to keep a constant height and width on the spinner's space on the screen while it spins
const SpinnerContainer = styled.div`
    height: 65px;
    width: 65px;
`

export const InstallingSampleDocSetsCoachmark = (props: { docSetName?: string }): JSX.Element => {
    const spinnerStyle: Partial<ISpinnerStyles> = {
        circle: {
            width: `50px`,
            height: `50px`,
            borderWidth: `5px`,
        }
    }

    return (
        <Container>
            <InfoView
                icon={<CoachmarkIcon src={emptyDocSetsUrl} />}
                titleText={<>Installing {props.docSetName ? <b>{props.docSetName}</b> : "your docset"}...</>}
                secondaryText={["Please wait while your doc set is installed."]}
                children={<SpinnerContainer><Spinner styles={spinnerStyle} /></SpinnerContainer>} />
        </Container>
    );
}
